/**
 * Manually fire resize() on a chart.js chart when showChartModal changes in vuex.
 * This is a hack to ensure the chart.js responsive resize watcher initializes in IE11.
 * See KBWT-402; The chart initializes inside a hidden chart modal with display: none,
 * so the initial height/width are 0, and chart.js@2.7.2 doesn't resize when the modal is shown.
 * Include this on a chart component. This assumes the chart is called `this.chart`
 */
export default {
    computed: {
        showChartModal() {
            return this.$store.state.showChartModal;
        },
    },
    watch: {
        // manually fire chart.resize() whenever the chart state changes
        showChartModal() {
            if (this.chart) {
                this.chart.resize();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/ie11ChartResize.js